import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { DnRecord } from '../_models';
import { BaseResponse, ListResponse, ArrayResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DnRecordService {

  constructor(private http: HttpClient) { }

  getDnRecord(filter: any): Observable<any> { //detail
    return this.http.post(`${environment.apiUrl}/3rd-party/dn/detail`, filter)
    .pipe(
      map((data: BaseResponse) => {
        return data.data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getAll(filter: any): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/3rd-party/dn/list`, filter)
    .pipe(
      map((data: any) => {
        if(data.status !== 1 || (data.status == 1 && !data.data.list)){
          return {status: null, msg: data.msg};
        }else{
          return new ListResponse().deserialize(data, DnRecord);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

}
